import { toast } from "react-toastify";
import {
  addCustomerService,
  deleteCustomerService,
  editCustomerService,
  getCustomersListService,
} from "../../Services/CustomerService";
import {
  addAdminFailure,
  addAdminStart,
  addAdminSuccess,
  deleteAdminFailure,
  deleteAdminStart,
  deleteAdminSuccess,
  editAdminFailure,
  editAdminStart,
  editAdminSuccess,
  fetchAdminFailure,
  fetchAdminStart,
  fetchAdminSuccess,
  getAdminByIdFailure,
  getAdminByIdStart,
  getAdminByIdSuccess,
  updateAdminStatusFailure,
  updateAdminStatusStart,
  updateAdminStatusSuccess,
} from "./reducer";
import {
  addAdminService,
  getAdminByIdService,
  getAllAdminListService,
  updateAdminStatusService,
} from "../../Services/AdminService";

//thunk for fetch the category list
export const fetchAdminsList =
  (params = {}) =>
  async (dispatch) => {
    try {
      dispatch(fetchAdminStart());
      const response = await getAllAdminListService(params);

      if (params.isPagination === 0) {
        // const currentPagination = getState().MealCategory.pagination;
        dispatch(
          fetchAdminSuccess({
            admins: response.data, // full list
            // pagination: currentPagination,
            pagination: {
              totalPages: 1,
              totalElements: response.data.length,
              currentPage: 0,
              pageSize: response.data.length,
              isLastPage: true,
              isFirstPage: true,
            },
          })
        );
      } else if (response?.data?.content) {
        dispatch(
          fetchAdminSuccess({
            admins: response.data.content,
            pagination: {
              totalPages: response.data.totalPages,
              totalElements: response.data.totalElements,
              currentPage: response.data.pageable.pageNumber,
              pageSize: response.data.pageable.pageSize,
              isLastPage: response.data.last,
              isFirstPage: response.data.first,
            },
          })
        );
      } else {
        dispatch(fetchAdminFailure("No data found"));
      }
    } catch (error) {
      dispatch(fetchAdminFailure(error));
    }
  };

// //thunk for the addig the category

export const addAdmin = (requestParam) => async (dispatch) => {
  try {
    dispatch(addAdminStart());

    const response = await addAdminService(requestParam);

    if (response?.success) {
      toast.success(response.message);
      dispatch(addAdminSuccess(response));
    } else {
      toast.error("Something went wrong ");
      dispatch(addAdminFailure("Failed to add Admin"));
    }
  } catch (error) {
    toast.error(error);

    dispatch(addAdminFailure());
  }
};

// //this is the thunk for delete the category
// export const deleteCustomer = (customerId) => async (dispatch) => {
//   try {
//     dispatch(deleteAdminStart());

//     const response = await deleteCustomerService(customerId);

//     if (response?.success) {
//       toast.success(response.message);
//       dispatch(deleteAdminSuccess(categoryId));
//     } else {
//       toast.error("Failed to delete customer");
//       dispatch(deleteAdminFailure("Delete failed"));
//     }
//   } catch (error) {
//     toast.error(error);
//     dispatch(deleteAdminFailure(error));
//   }
// };

// //this tunk for the edit meal category
export const updateAdmin = (id, requestParam) => async (dispatch) => {
  try {
    dispatch(editAdminStart());
    const response = await editCustomerService(id, requestParam);

    if (response?.success) {
      toast.success(response.message);
      dispatch(editAdminSuccess(response));
    } else {
      dispatch(editAdminFailure("Failed to update admin"));
    }
  } catch (error) {
    toast.error(error);
    dispatch(editAdminFailure(error));
  }
};

export const updateAdminStatus =
  (userId, active) => async (dispatch, getState) => {
    try {
      dispatch(updateAdminStatusStart());

      const response = await updateAdminStatusService(
        userId,
        active.startDate,
        active.expiryDate
      );
      if (response?.success) {
        toast.success(response.message || "Admin status updated successfully");

        // const state = getState();
        // const admin = state.admi.users.find((u) => u.id === userId);

        // if (user) {
        //   const updatedUser = { ...user, active };
        dispatch(updateAdminStatusSuccess(userId));
        // }
      } else {
        dispatch(updateAdminStatusFailure("Failed to update admin status"));
        toast.error("Failed to update admin status");
      }
    } catch (error) {
      toast.error(error || "Something went wrong");
      dispatch(updateAdminStatusFailure(error));
    }
  };

export const fetchAdminDetails = (id) => async (dispatch) => {
  try {
    dispatch(getAdminByIdStart());
    const response = await getAdminByIdService(id);
    if (response?.data) {
      dispatch(getAdminByIdSuccess(response.data));
    } else {
      dispatch(getAdminByIdFailure("No Admin found"));
    }
  } catch (error) {
    toast.error(error);
    dispatch(getAdminByIdFailure(error));
  }
};
